import React from 'react';
import { Paper, Box, Grid, Typography } from '@material-ui/core';
import InsuranceIcon from './components/InsuranceIcon';

import InsuranceTypeList from './components/InsuranceTypeList';
import useCar from '../../../../context/useCar';
import { useIsDesktop, useTranslations } from 'components/utilities';

// Import styles
import { useStyles } from './styles';

const CarDetailsInsurance = ({ boxSizes }) => {
	const { t } = useTranslations();

	const classes = useStyles();

	const {
		carDetails: {
			car: { insurance: isInsuranceAvailable },
		},
	} = useCar();

	const isDesktop = useIsDesktop();

	if (!isInsuranceAvailable) {
		return null;
	}

	return (
		<Paper>
			<Box {...boxSizes}>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs="auto">
						<InsuranceIcon
							className={!isDesktop ? classes.insuranceIcon : null}
						/>
					</Grid>
					<Grid item xs="auto">
						<Typography variant="h5" gutterBottom>
							{t('car.insuranceType')}
						</Typography>
					</Grid>
				</Grid>

				<InsuranceTypeList />
			</Box>
		</Paper>
	);
};

export default CarDetailsInsurance;
